import { db } from "../../../config/firebaseconfig";

export default function getAccountLicenses (id, accountType, updateState) {
  // const queryKey = accountType === 'district' ? 'district' : 'accountId'
  const queryKey = 'accountId'
  updateState({loadingAccountLicenses: true})
  return db.collection('accountLicenses').where(queryKey, '==', id).onSnapshot((snapshot) => {
    let accountLicenses = []
    snapshot.forEach(doc => {
      if (doc.exists) {
        if (!doc.data().deleted) accountLicenses.push(doc.data())
      }
    })
    updateState({accountLicenses, loadingAccountLicenses: false})
  },
  error => {
    console.log(error)
    updateState({error, loadingAccountLicenses: false})
  })
}


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/getAccountLicenses.js